<template>
<div>

    <v-layout my-5>
        <v-flex xs12 xl8 offset-xl2>
            <v-layout align-center>
                <h1 class="text-xs-left display-2 my-2">Create Class</h1>
                <v-spacer></v-spacer>
                <v-btn class="btn" color="primary" @click="copyCourseDialog = true">copy a course</v-btn>
            </v-layout>
        </v-flex>
    </v-layout>

    <v-layout row wrap>
        <v-flex xs12 xl8 offset-xl2 mb-5>
            <v-card>

                <div v-if="laravelErrors.active" class="text-xs-center">
                    <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg[0] }}
                    </v-chip>
                </div>

                <v-card-text>
                    <v-form>
                        <v-layout row wrap>
                            <v-flex xs6 px-2>
                                <v-text-field label="Section" name="section" v-model="section" v-validate="'required'" required></v-text-field>
                                <span class="error--text">{{ errors.first('section') }}</span>
                            </v-flex>
                            <v-flex xs6 px-2>
                                <v-text-field label="Name" name="name" v-model="name" v-validate="'required'" required></v-text-field>
                                <span class="error--text">{{ errors.first('name') }}</span>
                            </v-flex>
                            <v-flex xs12 px-2 mb-4>
                                <label class="v-label theme--light">Description</label>
                                <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '300' }" v-model="description" v-validate="'required'" name="description">
                                </editor>
                                <span class="error--text pl-2">{{ errors.first('description') }}</span>
                            </v-flex>
                            <v-flex xs3 px-2>
                                <v-text-field label="Max Seats" v-model="maxSeats" name="maxSeats" v-validate="'required'">
                                </v-text-field>
                                <span class="error--text">{{ errors.first('maxSeats') }}</span>
                            </v-flex>
                            <v-flex xs3 px-2>
                                <v-text-field label="Room #" v-model="room" name="room">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs3 px-2>
                                <v-select :items="['All Day', '1', '2', '3', '4', '5', '6', '7', '8']" label="Period" v-model="period" name="period" v-validate="'required'">
                                </v-select>
                                <span class="error--text">{{ errors.first('period') }}</span>
                            </v-flex>
                            <v-flex xs3 px-2>
                                <v-select :items="daysArray" label="Day" v-model="day" name="day" v-validate="'required'">
                                </v-select>
                                <span class="error--text">{{ errors.first('day') }}</span>
                            </v-flex>
                            <v-flex xs4 px-2>
                                <v-text-field name="time" label="Time" v-model="time" v-validate="'required'">
                                </v-text-field>
                                <span class="error--text">{{ errors.first('time') }}</span>
                            </v-flex>
                            <v-flex xs4 px-2>
                                <v-autocomplete :items="teachers" label="Teacher" name="teacher" :item-text="teacherDisplay" v-model="teacher" type="select" search-input return-object v-validate="'required'">
                                </v-autocomplete>
                                <!-- v-validate is not working on teacher select for some reason, but have laravel errors for this -->
                                <span class="error--text">{{ errors.first('teacher') }}</span>
                            </v-flex>
                            <v-flex xs4 px-2>
                                <v-select :items="semesters" item-value="name" item-text="name" label="Semester" v-model="semester" name="semester" v-validate="'required'">
                                </v-select>
                                <span class="error--text">{{ errors.first('semester') }}</span>
                            </v-flex>
                            <v-flex xs12 px-2 my-3>
                                <v-text-field label="Section Restrictions" v-model="restrictions" name="restrictions" v-validate="{regex: /^([0-9]{2,4})(,[0-9]{2,4})*$/}">
                                </v-text-field>
                                <span class="error--text">{{ errors.first('restrictions') }}</span>
                            </v-flex>
                            <v-flex xs12 px-2 my-3>
                                <h4 class="subheader">Grades</h4>
                                <v-checkbox class="px-3 d-inline-block" value="K" label="K" name="grade" v-model="checkedGrades" v-validate="'required'"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="1" label="1" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="2" label="2" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="3" label="3" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="4" label="4" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="5" label="5" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="6" label="6" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="7" label="7" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="8" label="8" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="9" label="9" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="10" label="10" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="11" label="11" name="grade" v-model="checkedGrades"></v-checkbox>
                                <v-checkbox class="px-3 d-inline-block" value="12" label="12" name="grade" v-model="checkedGrades"></v-checkbox>
                                <div class="error--text">{{ errors.first('grade') }}</div>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout align-center mt-5>
                                    <p class="green--text title" v-show="roster.copied">
                                        Roster has been copied
                                        <v-icon>check_circle</v-icon>
                                    </p>
                                    <v-spacer></v-spacer>
                                    <v-btn class="white--text right green" @click="onSubmit">Save</v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>

        </v-flex>
    </v-layout>

    <v-dialog v-model="addedAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" type="success">Class successfully created!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click.stop="addedAlert = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="copyCourseDialog" max-width="500px">
        <copy-dialog :active="copyCourseDialog" @close="copyCourseDialog = false" @success="copyCourseData">
        </copy-dialog>
    </v-dialog>

</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import CopyDialog from './CopyDialog.vue'

export default {
    components: {
        editor: Editor,
        CopyDialog: CopyDialog
    },
    data() {
        return {
            addedAlert: false,
            copyCourseDialog: false,
            section: '',
            name: '',
            description: '',
            teacher: {},
            checkedGrades: [],
            maxSeats: '',
            room: '',
            restrictions: '',
            period: '',
            daysArray: [{
                    text: 'Mon',
                    value: 'M'
                },
                {
                    text: 'Tue/Thu',
                    value: 'T/TH'
                },
                {
                    text: 'Wed',
                    value: 'W'
                },
                {
                    text: 'Fri',
                    value: 'F'
                }
            ],
            day: '',
            time: '',
            semester: '',
            roster: {
                copied: false,
                enrolled: []
            },
            laravelErrors: {
                active: false,
                messages: []
            }
        }
    },
    computed: {
        teachers() {
            return this.$store.state.admin.teachers
        },
        semesters() {
            return this.$store.state.semesterModule.semesters
        },
        courseCopy() {
            return this.$store.state.courseModule.courseInfo
        },
        culprit() {
            return this.$store.getters.culprit
        }
    },
    created() {
        this.$store.dispatch('getTeachers')
        this.$store.commit('clearErrors')
        this.clearErrors()
    },
    methods: {
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    const course = {
                        teacher_id: this.teacher.id,
                        section: this.section,
                        name: this.name,
                        description: this.description,
                        grade: this.checkedGrades.toString(),
                        max_seats: this.maxSeats,
                        room: this.room,
                        period: this.period,
                        restrictions: this.restrictions,
                        days: this.day,
                        time: this.time,
                        semester: this.semester,
                        roster: this.roster,
                        culprit: this.culprit
                    }
                    this.$store.dispatch('createCourse', course).then(() => {
                            this.teacher = {}
                            this.section = ''
                            this.name = ''
                            this.description = ''
                            this.maxSeats = ''
                            this.room = ''
                            this.period = ''
                            this.restrictions = ''
                            this.day = ''
                            this.time = ''
                            this.semester = ''
                            this.checkedGrades = []
                            this.roster.copied = false
                            this.roster.enrolled = []
                            // errors won't clear unless pushed onto stack later
                            setTimeout(() => {
                                this.clearErrors()
                            })
                            this.addedAlert = true
                        })
                        .catch((e) => {
                            // need to catch laravel errors and display
                            this.laravelErrors.active = true
                            this.laravelErrors.messages = e.response.data.errors
                        })
                }
            })
        },
        teacherDisplay: item => item.first_name + ' ' + item.last_name,
        clearErrors() {
            this.errors.clear()
            this.laravelErrors.active = false
            this.laravelErrors.messages = []
        },
        copyCourseData() {
            this.copyCourseDialog = false
            this.section = this.courseCopy.section
            this.name = this.courseCopy.name
            this.description = this.courseCopy.description
            this.teacher = this.courseCopy.teacher
            this.checkedGrades = this.courseCopy.grade.split(',')
            this.maxSeats = this.courseCopy.max_seats
            this.room = this.courseCopy.room
            this.restrictions = this.courseCopy.restrictions
            this.period = this.courseCopy.period
            this.day = this.courseCopy.days
            this.time = this.courseCopy.time

            if (this.courseCopy.enrolled) {
                this.roster.copied = true
                this.roster.enrolled = this.courseCopy.enrolled
            } else {
                this.roster.copied = false
                this.roster.enrolled = []
            }
        }
    }
}
</script>
